import classNames from "classnames";
import * as React from "react";
import { MenuContextProvider } from "~/sharedComponents/menu/MenuContext";
import { Marker } from "~/sharedComponents/userflow/utils/marker";
import * as styles from "./Menu.less";

export const Menu: React.FunctionComponent<{ className?: string } & Marker> = ({
    className,
    children,
    "data-testid": dataTestId,
}) => {
    const ref = React.useRef<HTMLDivElement>();
    React.useLayoutEffect(() => {
        ref.current.focus();
    }, []);

    return (
        <MenuContextProvider>
            <div className={classNames(styles.menu, className)} data-testid={dataTestId} tabIndex={-1} ref={ref}>
                {children}
            </div>
        </MenuContextProvider>
    );
};
